import React, { Component } from 'react';
import { ErrorCode, INTERMEDIATE_OUTPUT_FILES } from '../../../const';
import { v4 as uuidv4 } from 'uuid';
import Alert from 'sweetalert-react';
import * as Http from '../../../http'
import * as Business from '../../../utils/business'
import Loading from '../../../components/Loading'
import { ProgressBar, MenuItem, DropdownButton, FormGroup, FormControl, InputGroup, Button, Table, ControlLabel } from 'react-bootstrap';
import UpdateNameAndReportDateModalModal from '../../../components/UpdateNameAndReportDate';

const dicSingleConsol = {
  'single': 'SINGLE',
  'consol': 'CONSOL',
}

const dicFilterModule = {
  'cr_cor': 'CR COR',
  'mr_ccr': 'MR CCR',
  'or': 'OR',
  'irrbb_lr': 'IRRBB LR',
}

const dicFilterPeriods = {
  'all': 'All',
  'none': 'None',
  't0': 'T0',
  't1': 'T1',
  't2': 'T2',
  't3': 'T3',
}
const dicFilterScenario = {
  'all': 'All',
  'none': 'None',
}

const dicScenario = {
  'lowest_car': 'CAR thấp nhất',
  'lowest_lev': 'LEV thấp nhất',
}

class FileInfo extends Component {
  constructor(props) {
    super(props);
    const fileInfo = props.location.state || {};
    const lstInputFiles = fileInfo.input_files ? JSON.parse(fileInfo.input_files) : [];
    this.state = {
      singleConsol: 'single',
      scenario: 'lowest_car',
      filterIntermediateOutput: {
        scenario: 'all',
        period: 'all',
        module: 'cr_cor'
      },
      isShowUpdateNameAndReportDateModal: false,
      isSelectAllInput: false,
      isSelectAllOutput: false,
      isSelectAlIntermediateOutput: false,
      fileInfo: fileInfo,
      lstInput: lstInputFiles.map(e => ({ input: e.name, upload_by: fileInfo.upload_by, upload_time: Business.convertToFullDate(fileInfo.upload_time) })),
      lstOutput: [],
      dicIntermediateOutputByFilter: {},
      lstIntermediateOutput: [],
      failedDownloadsList: [],
      reportDate: Business.convertToDate(fileInfo.report_date),
      reportName: fileInfo.file_name || '',
      status: Business.convertFileStatus(fileInfo.status),
      reason: fileInfo.reason,
      loading: false,
      hasResult: false,
      showRejectAlert: false,
      showFileDownloadError: false,
      isDisableRejectButton: fileInfo.status !== Business.ENUMS.FILE_STATUS.WAITING_FOR_APPROVAL,
      isDisableApprovalButton: fileInfo.status !== Business.ENUMS.FILE_STATUS.WAITING_FOR_APPROVAL,
      isDisableReasonInput: fileInfo.status !== Business.ENUMS.FILE_STATUS.WAITING_FOR_APPROVAL,
      isDisableCalculateButton: fileInfo.status !== Business.ENUMS.FILE_STATUS.APPROVED && fileInfo.status !== Business.ENUMS.FILE_STATUS.CALCULATION_STOPPED,
    }
  }

  listReportWillDelete = null;

  componentDidMount() {
    clearGetBatchDownloadInterval();
    Http.getListScenarios(this.state.reportDate, this.state.reportName)
    .then(data => {
      if (data && data.Success && data.Data) {
        for (let i = 0; i < data.Data.length; i++) {
          dicScenario[data.Data[i].toLowerCase()] = data.Data[i].toUpperCase();
          dicFilterScenario[data.Data[i].toLowerCase()] = data.Data[i].toUpperCase();
        }
      }
      if (this.state.fileInfo.status === Business.ENUMS.FILE_STATUS.CALCULATED) {
        this.getReportList();
      } else {
        this.setState({ loading: false });
      }
    })
  }


  mappingDicIntermediateOutputByFilter = (lstIntermediateOutput) => {
    const dicIntermediateOutputByFilter = {};
    if (lstIntermediateOutput && lstIntermediateOutput.length > 0) {
      for (let i = 0; i < lstIntermediateOutput.length; i++) {
        const item = lstIntermediateOutput[i];
        const report_name = `${item.report_name}`.toLowerCase();

        const isContain = (array, reportName) => {
          let result = false;
          array.forEach(s => {
            if (`${reportName}`.toLowerCase().includes(`${s}`.toLowerCase())) {
              result = true;
              return;
            }
          })
          return result;
        }

        let module = '';
        if (isContain(INTERMEDIATE_OUTPUT_FILES.CR_COR, report_name)) {
          module = 'cr_cor';
        } else if (isContain(INTERMEDIATE_OUTPUT_FILES.MR_CCR, report_name)) {
          module = 'mr_ccr';
        } else if (isContain(INTERMEDIATE_OUTPUT_FILES.OR, report_name)) {
          module = 'or';
        } else {
          module = 'irrbb_lr'
        }
     
        if (!dicIntermediateOutputByFilter[`${module}_all_all`]) dicIntermediateOutputByFilter[`${module}_all_all`] = {};
        if (!dicIntermediateOutputByFilter[`${module}_all_none`]) dicIntermediateOutputByFilter[`${module}_all_none`] = {};
        if (!dicIntermediateOutputByFilter[`${module}_all_t0`]) dicIntermediateOutputByFilter[`${module}_all_t0`] = {};
        if (!dicIntermediateOutputByFilter[`${module}_all_t1`]) dicIntermediateOutputByFilter[`${module}_all_t1`] = {};
        if (!dicIntermediateOutputByFilter[`${module}_all_t2`]) dicIntermediateOutputByFilter[`${module}_all_t2`] = {};
        if (!dicIntermediateOutputByFilter[`${module}_all_t3`]) dicIntermediateOutputByFilter[`${module}_all_t3`] = {};
        let isHasScenario = false;
        Object.keys(dicFilterScenario).forEach(s => {
          if (s === 'all') return;
          if (!dicIntermediateOutputByFilter[`${module}_${s}_all`]) dicIntermediateOutputByFilter[`${module}_${s}_all`] = {};
          if (!dicIntermediateOutputByFilter[`${module}_${s}_none`]) dicIntermediateOutputByFilter[`${module}_${s}_none`] = {};
          if (!dicIntermediateOutputByFilter[`${module}_${s}_t0`]) dicIntermediateOutputByFilter[`${module}_${s}_t0`] = {};
          if (!dicIntermediateOutputByFilter[`${module}_${s}_t1`]) dicIntermediateOutputByFilter[`${module}_${s}_t1`] = {};
          if (!dicIntermediateOutputByFilter[`${module}_${s}_t2`]) dicIntermediateOutputByFilter[`${module}_${s}_t2`] = {};
          if (!dicIntermediateOutputByFilter[`${module}_${s}_t3`]) dicIntermediateOutputByFilter[`${module}_${s}_t3`] = {};
          if (report_name.includes(`_${s}_`)) {
            dicIntermediateOutputByFilter[`${module}_all_all`][report_name] = item;
            dicIntermediateOutputByFilter[`${module}_${s}_all`][report_name] = item;
            if (report_name.includes(`_t0_`)) {
              dicIntermediateOutputByFilter[`${module}_${s}_t0`][report_name] = item;  
              dicIntermediateOutputByFilter[`${module}_all_t0`][report_name] = item;
            } else if (report_name.includes(`_t1_`)) {
              dicIntermediateOutputByFilter[`${module}_${s}_t1`][report_name] = item;  
              dicIntermediateOutputByFilter[`${module}_all_t1`][report_name] = item;
            } else if (report_name.includes(`_t2_`)) {
              dicIntermediateOutputByFilter[`${module}_${s}_t2`][report_name] = item;  
              dicIntermediateOutputByFilter[`${module}_all_t2`][report_name] = item;
            } else if (report_name.includes(`_t3_`)) {
              dicIntermediateOutputByFilter[`${module}_${s}_t3`][report_name] = item;  
              dicIntermediateOutputByFilter[`${module}_all_t3`][report_name] = item;
            } else {
              dicIntermediateOutputByFilter[`${module}_${s}_none`][report_name] = item;  
              dicIntermediateOutputByFilter[`${module}_all_none`][report_name] = item;
            }
            isHasScenario = true;
          }
        })
        if (!isHasScenario) {
          dicIntermediateOutputByFilter[`${module}_all_all`][report_name] = item;
          dicIntermediateOutputByFilter[`${module}_none_all`][report_name] = item;
          if (report_name.includes(`_t0_`)) {
            dicIntermediateOutputByFilter[`${module}_all_t0`][report_name] = item;
          } else if (report_name.includes(`_t1_`)) {
            dicIntermediateOutputByFilter[`${module}_all_t1`][report_name] = item;
          } else if (report_name.includes(`_t2_`)) {
            dicIntermediateOutputByFilter[`${module}_all_t2`][report_name] = item;
          } else if (report_name.includes(`_t3_`)) {
            dicIntermediateOutputByFilter[`${module}_all_t3`][report_name] = item;
          } else {
            dicIntermediateOutputByFilter[`${module}_none_none`][report_name] = item;
            dicIntermediateOutputByFilter[`${module}_all_none`][report_name] = item;
          }
        }
      }
    }
    return dicIntermediateOutputByFilter;
  }

  getReportList = () => {
    Http.getListReport(Business.COMPONENT.ICAAP, this.state.fileInfo.file_name)
      .then(data => {
        const lstOutput = [];
        const lstIntermediateOutput = [];
        if (data && data.Success && data.Data) {
          data.Data.forEach(item => {
            if (!Business.isOutputFile(item.report_name)) return;
            item.created = Business.convertToFullDate(item.created);
            if (Business.isIntermediateOutputFiles(item.report_name)) {
              lstIntermediateOutput.push(item);
            } else {
              lstOutput.push(item);
            }
          });
        }
        const dicIntermediateOutputByFilter = this.mappingDicIntermediateOutputByFilter(lstIntermediateOutput);
        this.setState({
          lstOutput: lstOutput,
          lstIntermediateOutput: lstIntermediateOutput,
          dicIntermediateOutputByFilter: dicIntermediateOutputByFilter,
          loading: false
        }, () => {
          this.onChangeFilterIntermediateOutput();
        })
      })
  }

  onReject = () => {
    this.setState({ showRejectAlert: true });
  }

  onConfirmReject = () => {
    Http.updateUploadInfo(Business.COMPONENT.ICAAP, this.state.reportDate, this.state.reportName, Business.ENUMS.FILE_STATUS.REJECTED, this.state.reason)
      .then(res => {
        if (!res) {
          Business.showAlert({ title: 'Error', content: 'Unknow Error' })
        } else {
          if (res.Success) {
            Business.showAlert({ title: 'Info', content: 'Successfully' });
            this.handleHideShowBtn(Business.ENUMS.FILE_STATUS.REJECTED);
            this.setState({ status: Business.convertFileStatus(Business.ENUMS.FILE_STATUS.REJECTED) });
          } else {
            switch (res.ErrorCode) {
              case ErrorCode.PermissionDenie:
                Business.showAlert({ title: 'Error', content: 'You are not permission' })
              default:
                Business.showAlert({ title: 'Error', content: 'Unknow Error' })
            }
          }
        }
      })
    this.setState({ showRejectAlert: false });
  }

  onApproval = () => {
    Http.updateUploadInfo(Business.COMPONENT.ICAAP, this.state.reportDate, this.state.reportName, Business.ENUMS.FILE_STATUS.APPROVED, null)
      .then(res => {
        if (!res) {
          Business.showAlert({ title: 'Error', content: 'Unknow Error' })
        } else {
          if (res.Success) {
            Business.showAlert({ title: 'Info', content: 'Successfully' });
            this.handleHideShowBtn(Business.ENUMS.FILE_STATUS.APPROVED);
            this.setState({ status: Business.convertFileStatus(Business.ENUMS.FILE_STATUS.APPROVED) });
          } else {
            switch (res.ErrorCode) {
              case ErrorCode.PermissionDenie:
                Business.showAlert({ title: 'Error', content: 'You are not permission' })
              default:
                Business.showAlert({ title: 'Error', content: 'Unknow Error' })
            }
          }
        }
      })
    this.setState({ showRejectAlert: false });
  }

  onCalculate = async () => {
    const isCalculating = await Business.hasBatchCalculating();
    if (isCalculating) {
      Business.showAlert({
        title: 'Error',
        content: 'The system is busy. Please try again in a few moments.'
      })
      return;
    }

    this.handleHideShowBtn(Business.ENUMS.FILE_STATUS.CALCULATING);
    this.setState({ loading: true, errorCode: ErrorCode.PendingBatchProcessing, status: Business.convertFileStatus(Business.ENUMS.FILE_STATUS.CALCULATING) });
    Http.calculate(this.state.reportDate, this.state.reportName, this.state.singleConsol, this.state.scenario, true)
      .then(res => {
        this.setState({ loading: false });
        if (res && res.ErrorCode === ErrorCode.PendingBatchProcessing) {
          this.onGetBatchResponse();
        } else {
          this.handleCalculateResponse(res);
        }
      })
  }

  onSelectInput = inputName => {
    if (inputName === 'SELECT_ALL') {
      if (this.state.isSelectAllInput === true) {
        this.setState({ isSelectAllInput: false });
        this.state.lstInput.map(item => { item.select = false });
      } else {
        this.setState({ isSelectAllInput: true });
        this.state.lstInput.map(item => { item.select = true });
      }
    } else {
      this.state.lstInput.map(item => {
        if (item.input === inputName) {
          if (item.select === true) {
            item.select = false;
          } else {
            item.select = true;
          }
        }
      })
    }
    this.forceUpdate();
  }

  onSelectOutput = inputName => {
    if (inputName === 'SELECT_ALL') {
      if (this.state.isSelectAllOutput === true) {
        this.setState({ isSelectAllOutput: false });
        this.state.lstOutput.map(item => { item.select = false });
      } else {
        this.setState({ isSelectAllOutput: true });
        this.state.lstOutput.map(item => { item.select = true });
      }
    } else {
      this.state.lstOutput.map(item => {
        if (item.report_name === inputName) {
          if (item.select === true) {
            item.select = false;
          } else {
            item.select = true;
          }
        }
      })
    }
    this.forceUpdate();
  }

  onSelectIntermediateOutput = inputName => {
    if (inputName === 'SELECT_ALL') {
      if (this.state.isSelectAlIntermediateOutput === true) {
        this.setState({ isSelectAlIntermediateOutput: false });
        this.state.lstIntermediateOutput.map(item => { item.select = false });
      } else {
        this.setState({ isSelectAlIntermediateOutput: true });
        this.state.lstIntermediateOutput.map(item => { item.select = true });
      }
    } else {
      this.state.lstIntermediateOutput.map(item => {
        if (item.report_name === inputName) {
          if (item.select === true) {
            item.select = false;
          } else {
            item.select = true;
          }
        }
      })
    }
    this.forceUpdate();
  }

  onDownloadInputFiles = async () => {
    const lstFileSelected = [];
    if (this.state.lstInput && this.state.lstInput.length > 0) {
      for (let i = 0; i < this.state.lstInput.length; i++) {
        const item = this.state.lstInput[i];
        if (item.select === true) {
          lstFileSelected.push(item.input);
        }
      }
    }

    if (lstFileSelected.length > 0) {
      this.setState({loading: true});
      await handleBatchDownload(this.state.fileInfo, lstFileSelected, this.state.reportDate, this.state.reportName, 'input_calculation', Business.COMPONENT.ICAAP, message => { 
        if (message) {
          this.setState({ downloadProgressMessage: message });
        } else {
          this.setState({downloadProgressMessage: '', loading: false}); 
        }
      });
    }
  }

  onDownloadOutputFiles = async () => {
    const lstFileSelected = [];
    if (this.state.lstOutput && this.state.lstOutput.length > 0) {
      for (let i = 0; i < this.state.lstOutput.length; i++) {
        const item = this.state.lstOutput[i];
        if (item.select === true) {
          lstFileSelected.push(item.report_name);
        }
      }
    }

    if (lstFileSelected.length > 0) {
      this.setState({loading: true});
      await handleBatchDownload(this.state.fileInfo, lstFileSelected, this.state.reportDate, this.state.reportName, null, Business.COMPONENT.ICAAP, message => { 
        if (message) {
          this.setState({ downloadProgressMessage: message });
        } else {
          this.setState({downloadProgressMessage: '', loading: false}); 
        }
      });
    }
  }

  onDownloadIntermediateOutputFiles = async () => {
    const lstFileSelected = [];
    if (this.state.lstIntermediateOutput && this.state.lstIntermediateOutput.length > 0) {
      for (let i = 0; i < this.state.lstIntermediateOutput.length; i++) {
        const item = this.state.lstIntermediateOutput[i];
        if (item.select === true) {
          lstFileSelected.push(item.report_name);
        }
      }
    }

    if (lstFileSelected.length > 0) {
      this.setState({loading: true});
      await handleBatchDownload(this.state.fileInfo, lstFileSelected, this.state.reportDate, this.state.reportName, null, Business.COMPONENT.ICAAP, message => { 
        if (message) {
          this.setState({ downloadProgressMessage: message });
        } else {
          this.setState({downloadProgressMessage: '', loading: false}); 
        }
      });
    }
  }

  onGetBatchResponse = () => {
    const intervalId = setInterval(() => {
      console.warn(`${this.state.reportName} | Request to get batch response`);
      Http.getBatchResult(this.state.reportDate, this.state.reportName)
        .then(res => {
          this.handleGetBatchUploadingResponse(res);
        })
    }, 3000);
    lstIntervalId.push(intervalId);
  }

  handleHideShowBtn(statusOfBatch) {
    if (statusOfBatch === Business.ENUMS.FILE_STATUS.REJECTED) {
      this.setState({
        isDisableRejectButton: true,
        isDisableApprovalButton: true,
        isDisableReasonInput: true,
        isDisableCalculateButton: true,
      });
    }
    if (statusOfBatch === Business.ENUMS.FILE_STATUS.APPROVED || statusOfBatch === Business.ENUMS.FILE_STATUS.CALCULATION_STOPPED) {
      this.setState({
        isDisableRejectButton: true,
        isDisableApprovalButton: true,
        isDisableReasonInput: true,
        isDisableCalculateButton: false,
      });
    }
    if (statusOfBatch === Business.ENUMS.FILE_STATUS.CALCULATING) {
      this.setState({
        isDisableRejectButton: true,
        isDisableApprovalButton: true,
        isDisableReasonInput: true,
        isDisableCalculateButton: true,
      });
    }
  }

  handleErrorCode(res) {
    this.handleHideShowBtn(Business.ENUMS.FILE_STATUS.CALCULATION_STOPPED);
    this.setState({ status: Business.convertFileStatus(Business.ENUMS.FILE_STATUS.CALCULATION_STOPPED) });
    console.log(`Response: ${JSON.stringify((res || {}))}`);
    if (res) {
      switch (res.ErrorCode) {
        case ErrorCode.PermissionDenie:
          Business.showAlert({ title: 'Error', content: 'You are not permission' })
          break;
        case ErrorCode.Empty:
          Business.showAlert({ title: 'Error', content: 'File is empty' })
          break;
        case ErrorCode.Exist:
          Business.showAlert({ title: 'Error', content: 'Name already exists in the system' })
          break;
        case ErrorCode.DataInvalid:
          Business.showAlert({ title: 'Error', content: res.Data || 'System Error' })
          break;
        case ErrorCode.UnknowError:
          Business.showAlert({ title: 'Error', content: res.Data || 'System Error' })
          break;
        default:
          Business.showAlert({ title: 'Error', content: res.Data || 'Unknow Error' })
          break;
      }
    } else {
      Business.showAlert({ title: 'Error', content: 'Unknow Error' })
    }
  }

  handleCalculateResponse = (res) => {
    const errorCode = res ? res.ErrorCode : null;
    this.setState({ errorCode });
    if (res && res.Success) {
      const data = res.Data || {};
      this.setState({
        hasResult: true,
        icaapConsolReport: data
      })
    } else {
      this.handleErrorCode(res);
    }
  }

  handleGetBatchUploadingResponse = (res) => {
    if (res) {
      if (res.ErrorCode === ErrorCode.PendingBatchProcessing) {
        console.warn(`${this.state.reportName} | Received state: PendingBatchProcessing`);
      } else {
        console.warn(`${this.state.reportName} | Received state: Success`);
        const errorCode = res ? res.ErrorCode : null;
        this.setState({ errorCode });
        if (res && res.ErrorCode !== ErrorCode.PendingBatchProcessing) {
          clearGetBatchResponseInterval(this.state.reportName);
        }
        if (res && res.Success) {
          if (res.ErrorCode === ErrorCode.PendingBatchProcessing) {
            // console.warn('Received state: PendingBatchProcessing');
          } else if (res.ErrorCode === ErrorCode.BatchEmpty) {
            clearGetBatchResponseInterval(this.state.reportName);
            console.warn('Received state: BatchEmpty');
          } else {
            const data = res.Data || {};
            this.getReportList();
            this.setState({
              hasResult: true,
              icaapConsolReport: data,
              status: Business.convertFileStatus(Business.ENUMS.FILE_STATUS.CALCULATED)
            })
          }
        } else {
          this.handleErrorCode(res);
        }
      }
    }
  }

  renderPendingBatchProcessing = () => {
    return (
      <div>
        <div className="header">
          <h4 style={{ width: '100%', textAlign: 'center', paddingBottom: '50px', paddingTop: '50px' }} className="title">
            The system is calculating. Please wait...
          </h4>
        </div>
      </div>
    )
  }

  renderResult = () => {
    const report = this.state.icaapConsolReport || DEFAULT_REPORT;
    return (
      <div>
        <div style={{ height: '100px' }} />
        <Table striped bordered hover>
          <thead>
            <tr>
              <td style={style.bolder} rowSpan={2}>TT</td>
              <td style={style.bolder} rowSpan={2}>Các khoản mục</td>
              <td style={style.bolder} rowSpan={2}>Đơn vị</td>
              <td style={style.bolder} colSpan={2}>Năm t0</td>
              {/* <td></td> */}
              <td style={style.bolder} colSpan={2}>Năm t0+1</td>
              {/* <td></td> */}
              <td style={style.bolder} colSpan={2}>Năm t0+2</td>
              {/* <td></td> */}
              <td style={style.bolder} colSpan={2}>Năm t0+3</td>
              {/* <td></td> */}
            </tr>
            <tr>
              {/* <td></td> */}
              {/* <td></td> */}
              {/* <td></td> */}
              <td style={style.bolder}>BAU</td>
              <td style={style.bolder}>Stress</td>
              <td style={style.bolder}>BAU</td>
              <td style={style.bolder}>Stress</td>
              <td style={style.bolder}>BAU</td>
              <td style={style.bolder}>Stress</td>
              <td style={style.bolder}>BAU</td>
              <td style={style.bolder}>Stress</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={style.bolder}>I</td>
              <td style={style.bolder} colSpan={10}>Tài sản có rủi ro</td>
              {/* <td></td> */}
              {/* <td></td> */}
              {/* <td></td> */}
              {/* <td></td> */}
              {/* <td></td> */}
              {/* <td></td> */}
              {/* <td></td> */}
              {/* <td></td> */}
              {/* <td></td> */}
            </tr>
            <tr>
              <td style={style.bolder}>1</td>
              <td style={style.bolder}>RWA*E</td>
              <td style={style.bolder}>tỷ đồng</td>
              <td style={style.bolder}>{toAmountValue(report.rwa_e.bau_t0)}</td>
              <td style={style.bolder}>{toAmountValue(report.rwa_e.stress_t0)}</td>
              <td style={style.bolder}>{toAmountValue(report.rwa_e.bau_t1)}</td>
              <td style={style.bolder}>{toAmountValue(report.rwa_e.stress_t1)}</td>
              <td style={style.bolder}>{toAmountValue(report.rwa_e.bau_t2)}</td>
              <td style={style.bolder}>{toAmountValue(report.rwa_e.stress_t2)}</td>
              <td style={style.bolder}>{toAmountValue(report.rwa_e.bau_t3)}</td>
              <td style={style.bolder}>{toAmountValue(report.rwa_e.stress_t3)}</td>
            </tr>
            <tr>
              <td>1.1</td>
              <td>RWACR</td>
              <td>tỷ đồng</td>
              <td>{toAmountValue(report.rwa_cr.bau_t0)}</td>
              <td>{toAmountValue(report.rwa_cr.stress_t0)}</td>
              <td>{toAmountValue(report.rwa_cr.bau_t1)}</td>
              <td>{toAmountValue(report.rwa_cr.stress_t1)}</td>
              <td>{toAmountValue(report.rwa_cr.bau_t2)}</td>
              <td>{toAmountValue(report.rwa_cr.stress_t2)}</td>
              <td>{toAmountValue(report.rwa_cr.bau_t3)}</td>
              <td>{toAmountValue(report.rwa_cr.stress_t3)}</td>
            </tr>
            <tr>
              <td>1.2</td>
              <td>RWAOR</td>
              <td>tỷ đồng</td>
              <td>{toAmountValue(report.rwa_or.bau_t0)}</td>
              <td>{toAmountValue(report.rwa_or.stress_t0)}</td>
              <td>{toAmountValue(report.rwa_or.bau_t1)}</td>
              <td>{toAmountValue(report.rwa_or.stress_t1)}</td>
              <td>{toAmountValue(report.rwa_or.bau_t2)}</td>
              <td>{toAmountValue(report.rwa_or.stress_t2)}</td>
              <td>{toAmountValue(report.rwa_or.bau_t3)}</td>
              <td>{toAmountValue(report.rwa_or.stress_t3)}</td>
            </tr>
            <tr>
              <td>1.3</td>
              <td>RWAMR</td>
              <td>tỷ đồng</td>
              <td>{toAmountValue(report.rwa_mr.bau_t0)}</td>
              <td>{toAmountValue(report.rwa_mr.stress_t0)}</td>
              <td>{toAmountValue(report.rwa_mr.bau_t1)}</td>
              <td>{toAmountValue(report.rwa_mr.stress_t1)}</td>
              <td>{toAmountValue(report.rwa_mr.bau_t2)}</td>
              <td>{toAmountValue(report.rwa_mr.stress_t2)}</td>
              <td>{toAmountValue(report.rwa_mr.bau_t3)}</td>
              <td>{toAmountValue(report.rwa_mr.stress_t3)}</td>
            </tr>
            <tr>
              <td>1.4</td>
              <td>RWACOR</td>
              <td>tỷ đồng</td>
              <td>{toAmountValue(report.rwa_cor.bau_t0)}</td>
              <td>{toAmountValue(report.rwa_cor.stress_t0)}</td>
              <td>{toAmountValue(report.rwa_cor.bau_t1)}</td>
              <td>{toAmountValue(report.rwa_cor.stress_t1)}</td>
              <td>{toAmountValue(report.rwa_cor.bau_t2)}</td>
              <td>{toAmountValue(report.rwa_cor.stress_t2)}</td>
              <td>{toAmountValue(report.rwa_cor.bau_t3)}</td>
              <td>{toAmountValue(report.rwa_cor.stress_t3)}</td>
            </tr>
            <tr>
              <td>1.5</td>
              <td>RWAIRRBB</td>
              <td>tỷ đồng</td>
              <td>{toAmountValue(report.rwa_irrbb.bau_t0)}</td>
              <td>{toAmountValue(report.rwa_irrbb.stress_t0)}</td>
              <td>{toAmountValue(report.rwa_irrbb.bau_t1)}</td>
              <td>{toAmountValue(report.rwa_irrbb.stress_t1)}</td>
              <td>{toAmountValue(report.rwa_irrbb.bau_t2)}</td>
              <td>{toAmountValue(report.rwa_irrbb.stress_t2)}</td>
              <td>{toAmountValue(report.rwa_irrbb.bau_t3)}</td>
              <td>{toAmountValue(report.rwa_irrbb.stress_t3)}</td>
            </tr>
            <tr>
              <td>1.6</td>
              <td>RWAOMR</td>
              <td>tỷ đồng</td>
              <td>{toAmountValue(report.rwa_omr.bau_t0)}</td>
              <td>{toAmountValue(report.rwa_omr.stress_t0)}</td>
              <td>{toAmountValue(report.rwa_omr.bau_t1)}</td>
              <td>{toAmountValue(report.rwa_omr.stress_t1)}</td>
              <td>{toAmountValue(report.rwa_omr.bau_t2)}</td>
              <td>{toAmountValue(report.rwa_omr.stress_t2)}</td>
              <td>{toAmountValue(report.rwa_omr.bau_t3)}</td>
              <td>{toAmountValue(report.rwa_omr.stress_t3)}</td>
            </tr>
            <tr>
              <td style={style.bolder}>2</td>
              <td style={style.bolder}>∆RWA</td>
              <td style={style.bolder}>tỷ đồng</td>
              <td style={style.bolder}>{toAmountValue(report.delta_rwa.bau_t0)}</td>
              <td style={style.bolder}>{toAmountValue(report.delta_rwa.stress_t0)}</td>
              <td style={style.bolder}>{toAmountValue(report.delta_rwa.bau_t1)}</td>
              <td style={style.bolder}>{toAmountValue(report.delta_rwa.stress_t1)}</td>
              <td style={style.bolder}>{toAmountValue(report.delta_rwa.bau_t2)}</td>
              <td style={style.bolder}>{toAmountValue(report.delta_rwa.stress_t2)}</td>
              <td style={style.bolder}>{toAmountValue(report.delta_rwa.bau_t3)}</td>
              <td style={style.bolder}>{toAmountValue(report.delta_rwa.stress_t3)}</td>
            </tr>
            <tr>
              <td>2.1</td>
              <td>∆RWACR</td>
              <td>tỷ đồng</td>
              <td>{toAmountValue(report.delta_rwa_cr.bau_t0)}</td>
              <td>{toAmountValue(report.delta_rwa_cr.stress_t0)}</td>
              <td>{toAmountValue(report.delta_rwa_cr.bau_t1)}</td>
              <td>{toAmountValue(report.delta_rwa_cr.stress_t1)}</td>
              <td>{toAmountValue(report.delta_rwa_cr.bau_t2)}</td>
              <td>{toAmountValue(report.delta_rwa_cr.stress_t2)}</td>
              <td>{toAmountValue(report.delta_rwa_cr.bau_t3)}</td>
              <td>{toAmountValue(report.delta_rwa_cr.stress_t3)}</td>
            </tr>
            <tr>
              <td>2.2</td>
              <td>∆RWAOR</td>
              <td>tỷ đồng</td>
              <td>{toAmountValue(report.delta_rwa_or.bau_t0)}</td>
              <td>{toAmountValue(report.delta_rwa_or.stress_t0)}</td>
              <td>{toAmountValue(report.delta_rwa_or.bau_t1)}</td>
              <td>{toAmountValue(report.delta_rwa_or.stress_t1)}</td>
              <td>{toAmountValue(report.delta_rwa_or.bau_t2)}</td>
              <td>{toAmountValue(report.delta_rwa_or.stress_t2)}</td>
              <td>{toAmountValue(report.delta_rwa_or.bau_t3)}</td>
              <td>{toAmountValue(report.delta_rwa_or.stress_t3)}</td>
            </tr>
            <tr>
              <td>2.3</td>
              <td>∆RWAMR</td>
              <td>tỷ đồng</td>
              <td>{toAmountValue(report.delta_rwa_mr.bau_t0)}</td>
              <td>{toAmountValue(report.delta_rwa_mr.stress_t0)}</td>
              <td>{toAmountValue(report.delta_rwa_mr.bau_t1)}</td>
              <td>{toAmountValue(report.delta_rwa_mr.stress_t1)}</td>
              <td>{toAmountValue(report.delta_rwa_mr.bau_t2)}</td>
              <td>{toAmountValue(report.delta_rwa_mr.stress_t2)}</td>
              <td>{toAmountValue(report.delta_rwa_mr.bau_t3)}</td>
              <td>{toAmountValue(report.delta_rwa_mr.stress_t3)}</td>
            </tr>
            <tr>
              <td>2.4</td>
              <td>∆RWACOR</td>
              <td>tỷ đồng</td>
              <td>{toAmountValue(report.delta_rwa_cor.bau_t0)}</td>
              <td>{toAmountValue(report.delta_rwa_cor.stress_t0)}</td>
              <td>{toAmountValue(report.delta_rwa_cor.bau_t1)}</td>
              <td>{toAmountValue(report.delta_rwa_cor.stress_t1)}</td>
              <td>{toAmountValue(report.delta_rwa_cor.bau_t2)}</td>
              <td>{toAmountValue(report.delta_rwa_cor.stress_t2)}</td>
              <td>{toAmountValue(report.delta_rwa_cor.bau_t3)}</td>
              <td>{toAmountValue(report.delta_rwa_cor.stress_t3)}</td>
            </tr>
            <tr>
              <td>2.5</td>
              <td>∆RWAIRRBB</td>
              <td>tỷ đồng</td>
              <td>{toAmountValue(report.delta_rwa_irrbb.bau_t0)}</td>
              <td>{toAmountValue(report.delta_rwa_irrbb.stress_t0)}</td>
              <td>{toAmountValue(report.delta_rwa_irrbb.bau_t1)}</td>
              <td>{toAmountValue(report.delta_rwa_irrbb.stress_t1)}</td>
              <td>{toAmountValue(report.delta_rwa_irrbb.bau_t2)}</td>
              <td>{toAmountValue(report.delta_rwa_irrbb.stress_t2)}</td>
              <td>{toAmountValue(report.delta_rwa_irrbb.bau_t3)}</td>
              <td>{toAmountValue(report.delta_rwa_irrbb.stress_t3)}</td>
            </tr>
            <tr>
              <td>2.6</td>
              <td>∆RWAOMR</td>
              <td>tỷ đồng</td>
              <td>{toAmountValue(report.delta_rwa_omr.bau_t0)}</td>
              <td>{toAmountValue(report.delta_rwa_omr.stress_t0)}</td>
              <td>{toAmountValue(report.delta_rwa_omr.bau_t1)}</td>
              <td>{toAmountValue(report.delta_rwa_omr.stress_t1)}</td>
              <td>{toAmountValue(report.delta_rwa_omr.bau_t2)}</td>
              <td>{toAmountValue(report.delta_rwa_omr.stress_t2)}</td>
              <td>{toAmountValue(report.delta_rwa_omr.bau_t3)}</td>
              <td>{toAmountValue(report.delta_rwa_omr.stress_t3)}</td>
            </tr>
            <tr>
              <td style={style.bolder}>II</td>
              <td style={style.bolder} colSpan={10}>Đánh giá thay đổi về tỷ lệ an toàn vốn và các chỉ tiêu KVRR</td>
              {/* <td></td> */}
              {/* <td></td> */}
              {/* <td></td> */}
              {/* <td></td> */}
              {/* <td></td> */}
              {/* <td></td> */}
              {/* <td></td> */}
              {/* <td></td> */}
              {/* <td></td> */}
            </tr>
            <tr>
              <td style={style.bolder}>1</td>
              <td style={style.bolder}>Vốn tự có (CA)</td>
              <td style={style.bolder}>tỷ đồng</td>
              <td style={style.bolder}>{toAmountValue(report.von_tu_co_ca.bau_t0)}</td>
              <td style={style.bolder}>{toAmountValue(report.von_tu_co_ca.stress_t0)}</td>
              <td style={style.bolder}>{toAmountValue(report.von_tu_co_ca.bau_t1)}</td>
              <td style={style.bolder}>{toAmountValue(report.von_tu_co_ca.stress_t1)}</td>
              <td style={style.bolder}>{toAmountValue(report.von_tu_co_ca.bau_t2)}</td>
              <td style={style.bolder}>{toAmountValue(report.von_tu_co_ca.stress_t2)}</td>
              <td style={style.bolder}>{toAmountValue(report.von_tu_co_ca.bau_t3)}</td>
              <td style={style.bolder}>{toAmountValue(report.von_tu_co_ca.stress_t3)}</td>
            </tr>
            <tr>
              <td style={style.bolder}>2</td>
              <td style={style.bolder}>Vốn yêu cầu (CR)</td>
              <td style={style.bolder}>tỷ đồng</td>
              <td style={style.bolder}>{toAmountValue(report.von_yeu_cau_cr.bau_t0)}</td>
              <td style={style.bolder}>{toAmountValue(report.von_yeu_cau_cr.stress_t0)}</td>
              <td style={style.bolder}>{toAmountValue(report.von_yeu_cau_cr.bau_t1)}</td>
              <td style={style.bolder}>{toAmountValue(report.von_yeu_cau_cr.stress_t1)}</td>
              <td style={style.bolder}>{toAmountValue(report.von_yeu_cau_cr.bau_t2)}</td>
              <td style={style.bolder}>{toAmountValue(report.von_yeu_cau_cr.stress_t2)}</td>
              <td style={style.bolder}>{toAmountValue(report.von_yeu_cau_cr.bau_t3)}</td>
              <td style={style.bolder}>{toAmountValue(report.von_yeu_cau_cr.stress_t3)}</td>
            </tr>
            <tr>
              <td style={style.bolder}>3</td>
              <td style={style.bolder}>Vốn kinh tế (CE)</td>
              <td style={style.bolder}>tỷ đồng</td>
              <td style={style.bolder}>{toAmountValue(report.von_kinh_te_ce.bau_t0)}</td>
              <td style={style.bolder}>{toAmountValue(report.von_kinh_te_ce.stress_t0)}</td>
              <td style={style.bolder}>{toAmountValue(report.von_kinh_te_ce.bau_t1)}</td>
              <td style={style.bolder}>{toAmountValue(report.von_kinh_te_ce.stress_t1)}</td>
              <td style={style.bolder}>{toAmountValue(report.von_kinh_te_ce.bau_t2)}</td>
              <td style={style.bolder}>{toAmountValue(report.von_kinh_te_ce.stress_t2)}</td>
              <td style={style.bolder}>{toAmountValue(report.von_kinh_te_ce.bau_t3)}</td>
              <td style={style.bolder}>{toAmountValue(report.von_kinh_te_ce.stress_t3)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Thuế suất</td>
              <td>%</td>
              <td colSpan={2}>{toPercentValue(report.corp_tax.bau_t0)}</td>
              {/* <td>{toPercentValue(report.corp_tax.stress_t0)}</td> */}
              <td colSpan={2}>{toPercentValue(report.corp_tax.bau_t1)}</td>
              {/* <td>{toPercentValue(report.corp_tax.stress_t1)}</td> */}
              <td colSpan={2}>{toPercentValue(report.corp_tax.bau_t2)}</td>
              {/* <td>{toPercentValue(report.corp_tax.stress_t2)}</td> */}
              <td colSpan={2}>{toPercentValue(report.corp_tax.bau_t3)}</td>
              {/* <td>{toPercentValue(report.corp_tax.stress_t3)}</td> */}
            </tr>
            <tr>
              <td style={style.bolder}>4</td>
              <td style={style.bolder}>Δ PnL</td>
              <td style={style.bolder}>tỷ đồng</td>
              <td style={style.bolder}>{toAmountValue(report.delta_pnl.bau_t0)}</td>
              <td style={style.bolder}>{toAmountValue(report.delta_pnl.stress_t0)}</td>
              <td style={style.bolder}>{toAmountValue(report.delta_pnl.bau_t1)}</td>
              <td style={style.bolder}>{toAmountValue(report.delta_pnl.stress_t1)}</td>
              <td style={style.bolder}>{toAmountValue(report.delta_pnl.bau_t2)}</td>
              <td style={style.bolder}>{toAmountValue(report.delta_pnl.stress_t2)}</td>
              <td style={style.bolder}>{toAmountValue(report.delta_pnl.bau_t3)}</td>
              <td style={style.bolder}>{toAmountValue(report.delta_pnl.stress_t3)}</td>
            </tr>
            <tr>
              <td>4.1</td>
              <td>Thay đổi thu nhập lãi</td>
              <td>tỷ đồng</td>
              <td>{toAmountValue(report.thay_doi_thu_nhap_lai.bau_t0)}</td>
              <td>{toAmountValue(report.thay_doi_thu_nhap_lai.stress_t0)}</td>
              <td>{toAmountValue(report.thay_doi_thu_nhap_lai.bau_t1)}</td>
              <td>{toAmountValue(report.thay_doi_thu_nhap_lai.stress_t1)}</td>
              <td>{toAmountValue(report.thay_doi_thu_nhap_lai.bau_t2)}</td>
              <td>{toAmountValue(report.thay_doi_thu_nhap_lai.stress_t2)}</td>
              <td>{toAmountValue(report.thay_doi_thu_nhap_lai.bau_t3)}</td>
              <td>{toAmountValue(report.thay_doi_thu_nhap_lai.stress_t3)}</td>
            </tr>
            <tr>
              <td>4.2</td>
              <td>Thay đổi chi phí dự phòng</td>
              <td>tỷ đồng</td>
              <td>{toAmountValue(report.thay_doi_chi_phi_du_phong.bau_t0)}</td>
              <td>{toAmountValue(report.thay_doi_chi_phi_du_phong.stress_t0)}</td>
              <td>{toAmountValue(report.thay_doi_chi_phi_du_phong.bau_t1)}</td>
              <td>{toAmountValue(report.thay_doi_chi_phi_du_phong.stress_t1)}</td>
              <td>{toAmountValue(report.thay_doi_chi_phi_du_phong.bau_t2)}</td>
              <td>{toAmountValue(report.thay_doi_chi_phi_du_phong.stress_t2)}</td>
              <td>{toAmountValue(report.thay_doi_chi_phi_du_phong.bau_t3)}</td>
              <td>{toAmountValue(report.thay_doi_chi_phi_du_phong.stress_t3)}</td>
            </tr>
            <tr>
              <td>4.3</td>
              <td>Thay đổi thu nhập từ rủi ro thị trường</td>
              <td>tỷ đồng</td>
              <td>{toAmountValue(report.thay_doi_thu_nhap_tu_rui_ro_thi_truong.bau_t0)}</td>
              <td>{toAmountValue(report.thay_doi_thu_nhap_tu_rui_ro_thi_truong.stress_t0)}</td>
              <td>{toAmountValue(report.thay_doi_thu_nhap_tu_rui_ro_thi_truong.bau_t1)}</td>
              <td>{toAmountValue(report.thay_doi_thu_nhap_tu_rui_ro_thi_truong.stress_t1)}</td>
              <td>{toAmountValue(report.thay_doi_thu_nhap_tu_rui_ro_thi_truong.bau_t2)}</td>
              <td>{toAmountValue(report.thay_doi_thu_nhap_tu_rui_ro_thi_truong.stress_t2)}</td>
              <td>{toAmountValue(report.thay_doi_thu_nhap_tu_rui_ro_thi_truong.bau_t3)}</td>
              <td>{toAmountValue(report.thay_doi_thu_nhap_tu_rui_ro_thi_truong.stress_t3)}</td>
            </tr>
            <tr>
              <td>4.4</td>
              <td>Tổn thất rủi ro hoạt động</td>
              <td>tỷ đồng</td>
              <td>{toAmountValue(report.ton_that_rui_ro_hoat_dong.bau_t0)}</td>
              <td>{toAmountValue(report.ton_that_rui_ro_hoat_dong.stress_t0)}</td>
              <td>{toAmountValue(report.ton_that_rui_ro_hoat_dong.bau_t1)}</td>
              <td>{toAmountValue(report.ton_that_rui_ro_hoat_dong.stress_t1)}</td>
              <td>{toAmountValue(report.ton_that_rui_ro_hoat_dong.bau_t2)}</td>
              <td>{toAmountValue(report.ton_that_rui_ro_hoat_dong.stress_t2)}</td>
              <td>{toAmountValue(report.ton_that_rui_ro_hoat_dong.bau_t3)}</td>
              <td>{toAmountValue(report.ton_that_rui_ro_hoat_dong.stress_t3)}</td>
            </tr>
            <tr>
              <td>4.5</td>
              <td>Chi phí thanh khoản</td>
              <td>tỷ đồng</td>
              <td>{toAmountValue(report.chi_phi_thanh_khoan.bau_t0)}</td>
              <td>{toAmountValue(report.chi_phi_thanh_khoan.stress_t0)}</td>
              <td>{toAmountValue(report.chi_phi_thanh_khoan.bau_t1)}</td>
              <td>{toAmountValue(report.chi_phi_thanh_khoan.stress_t1)}</td>
              <td>{toAmountValue(report.chi_phi_thanh_khoan.bau_t2)}</td>
              <td>{toAmountValue(report.chi_phi_thanh_khoan.stress_t2)}</td>
              <td>{toAmountValue(report.chi_phi_thanh_khoan.bau_t3)}</td>
              <td>{toAmountValue(report.chi_phi_thanh_khoan.stress_t3)}</td>
            </tr>
            <tr>
              <td style={style.bolder}>5</td>
              <td style={style.bolder} colSpan={10}>Các tỷ lệ an toàn vốn</td>
              {/* <td style={style.bolder}></td> */}
              {/* <td style={style.bolder}></td> */}
              {/* <td style={style.bolder}></td> */}
              {/* <td style={style.bolder}></td> */}
              {/* <td style={style.bolder}></td> */}
              {/* <td style={style.bolder}></td> */}
              {/* <td style={style.bolder}></td> */}
              {/* <td style={style.bolder}></td> */}
              {/* <td style={style.bolder}></td> */}
            </tr>
            <tr>
              <td>5.1</td>
              <td>Tỷ lệ an toàn vốn (CAR)</td>
              <td>%</td>
              <td>{toPercentValue(report.ty_le_an_toan_von_car.bau_t0)}</td>
              <td>{toPercentValue(report.ty_le_an_toan_von_car.stress_t0)}</td>
              <td>{toPercentValue(report.ty_le_an_toan_von_car.bau_t1)}</td>
              <td>{toPercentValue(report.ty_le_an_toan_von_car.stress_t1)}</td>
              <td>{toPercentValue(report.ty_le_an_toan_von_car.bau_t2)}</td>
              <td>{toPercentValue(report.ty_le_an_toan_von_car.stress_t2)}</td>
              <td>{toPercentValue(report.ty_le_an_toan_von_car.bau_t3)}</td>
              <td>{toPercentValue(report.ty_le_an_toan_von_car.stress_t3)}</td>
            </tr>
            <tr>
              <td>5.2</td>
              <td>Tỷ lệ an toàn vốn cấp 1 (CT1)</td>
              <td>%</td>
              <td>{toPercentValue(report.ty_le_an_toan_von_cap_1_ct1.bau_t0)}</td>
              <td>{toPercentValue(report.ty_le_an_toan_von_cap_1_ct1.stress_t0)}</td>
              <td>{toPercentValue(report.ty_le_an_toan_von_cap_1_ct1.bau_t1)}</td>
              <td>{toPercentValue(report.ty_le_an_toan_von_cap_1_ct1.stress_t1)}</td>
              <td>{toPercentValue(report.ty_le_an_toan_von_cap_1_ct1.bau_t2)}</td>
              <td>{toPercentValue(report.ty_le_an_toan_von_cap_1_ct1.stress_t2)}</td>
              <td>{toPercentValue(report.ty_le_an_toan_von_cap_1_ct1.bau_t3)}</td>
              <td>{toPercentValue(report.ty_le_an_toan_von_cap_1_ct1.stress_t3)}</td>
            </tr>
            <tr>
              <td>5.3</td>
              <td>Tỷ lệ an toàn vốn chủ sở hữu cấp 1 (CET1)</td>
              <td>%</td>
              <td>{toPercentValue(report.ty_le_an_toan_von_chu_so_huu_cap_1_cet1.bau_t0)}</td>
              <td>{toPercentValue(report.ty_le_an_toan_von_chu_so_huu_cap_1_cet1.stress_t0)}</td>
              <td>{toPercentValue(report.ty_le_an_toan_von_chu_so_huu_cap_1_cet1.bau_t1)}</td>
              <td>{toPercentValue(report.ty_le_an_toan_von_chu_so_huu_cap_1_cet1.stress_t1)}</td>
              <td>{toPercentValue(report.ty_le_an_toan_von_chu_so_huu_cap_1_cet1.bau_t2)}</td>
              <td>{toPercentValue(report.ty_le_an_toan_von_chu_so_huu_cap_1_cet1.stress_t2)}</td>
              <td>{toPercentValue(report.ty_le_an_toan_von_chu_so_huu_cap_1_cet1.bau_t3)}</td>
              <td>{toPercentValue(report.ty_le_an_toan_von_chu_so_huu_cap_1_cet1.stress_t3)}</td>
            </tr>
            <tr>
              <td style={style.bolder}>6</td>
              <td style={style.bolder}>Tỷ lệ đòn bẩy</td>
              <td style={style.bolder}>%</td>
              <td>{toPercentValue(report.ty_le_don_bay.bau_t0)}</td>
              <td>{toPercentValue(report.ty_le_don_bay.stress_t0)}</td>
              <td>{toPercentValue(report.ty_le_don_bay.bau_t1)}</td>
              <td>{toPercentValue(report.ty_le_don_bay.stress_t1)}</td>
              <td>{toPercentValue(report.ty_le_don_bay.bau_t2)}</td>
              <td>{toPercentValue(report.ty_le_don_bay.stress_t2)}</td>
              <td>{toPercentValue(report.ty_le_don_bay.bau_t3)}</td>
              <td>{toPercentValue(report.ty_le_don_bay.stress_t3)}</td>
            </tr>
            <tr>
              <td style={style.bolder}>7</td>
              <td style={style.bolder}>Các chỉ tiêu khẩu vị rủi ro khác</td>
              <td style={style.bolder}></td>
              <td style={style.bolder}></td>
              <td style={style.bolder}></td>
              <td style={style.bolder}></td>
              <td style={style.bolder}></td>
              <td style={style.bolder}></td>
              <td style={style.bolder}></td>
              <td style={style.bolder}></td>
              <td style={style.bolder}></td>
            </tr>
            <tr>
              <td>7.1</td>
              <td>ROE</td>
              <td>%</td>
              <td>{toPercentValue(report.roe.bau_t0)}</td>
              <td>{toPercentValue(report.roe.stress_t0)}</td>
              <td>{toPercentValue(report.roe.bau_t1)}</td>
              <td>{toPercentValue(report.roe.stress_t1)}</td>
              <td>{toPercentValue(report.roe.bau_t2)}</td>
              <td>{toPercentValue(report.roe.stress_t2)}</td>
              <td>{toPercentValue(report.roe.bau_t3)}</td>
              <td>{toPercentValue(report.roe.stress_t3)}</td>
            </tr>
            <tr>
              <td>7.2</td>
              <td>RAROC</td>
              <td>%</td>
              <td>{toPercentValue(report.raroc.bau_t0)}</td>
              <td>{toPercentValue(report.raroc.stress_t0)}</td>
              <td>{toPercentValue(report.raroc.bau_t1)}</td>
              <td>{toPercentValue(report.raroc.stress_t1)}</td>
              <td>{toPercentValue(report.raroc.bau_t2)}</td>
              <td>{toPercentValue(report.raroc.stress_t2)}</td>
              <td>{toPercentValue(report.raroc.bau_t3)}</td>
              <td>{toPercentValue(report.raroc.stress_t3)}</td>
            </tr>
          </tbody>
        </Table>
      </div>
    )
  }

  handleSelectSingleConsolMethod = (eventKey, event) => {
    this.setState({ singleConsol: eventKey });
  }

  handleSelectFilterModuleMethod = (eventKey, event) => {
    const filterIntermediateOutput = this.state.filterIntermediateOutput;
    filterIntermediateOutput.module = eventKey;
    this.setState({ filterIntermediateOutput }, () => { this.onChangeFilterIntermediateOutput() });
  }

  handleSelectFilterPeriodsMethod = (eventKey, event) => {
    const filterIntermediateOutput = this.state.filterIntermediateOutput;
    filterIntermediateOutput.period = eventKey;
    this.setState({ filterIntermediateOutput }, () => { this.onChangeFilterIntermediateOutput() });
  }

  handleSelectFilterSecenariosMethod = (eventKey, event) => {
    const filterIntermediateOutput = this.state.filterIntermediateOutput;
    filterIntermediateOutput.scenario = eventKey;
    this.setState({ filterIntermediateOutput }, () => { this.onChangeFilterIntermediateOutput() });
  }

  onChangeFilterIntermediateOutput = () => {
    const filterIntermediateOutput = this.state.filterIntermediateOutput;
    const dicIntermediateOutputByFilter = this.state.dicIntermediateOutputByFilter;
    const { module, scenario, period } = filterIntermediateOutput;
    
    const lstIntermediateOutput = Object.values(dicIntermediateOutputByFilter[`${module}_${scenario}_${period}`] || {});
    this.setState({lstIntermediateOutput: lstIntermediateOutput });
  }


  handleSelectScenario = (eventKey, event) => {
    this.setState({ scenario: eventKey });
  }

  onShowUpdateNameAndReportDateModal = () => {
    this.setState({
      isShowUpdateNameAndReportDateModal: true
    })
  }

  onCloseUpdateNameAndReportDateModal = () => {
    this.setState({
      isShowUpdateNameAndReportDateModal: false,
    })
  }

  onCloseUpdateNameAndReportDateModalAndGetNewData = (reportDate, reportName) => {
    const objSearch = {
      report_date: reportDate,
      file_name: reportName
    }

    Http.getUploadManagement(Business.COMPONENT.ICAAP, objSearch)
      .then(data => {
        if (data && data.Success) {
          if (data.Data && data.Data.length === 1) {
            const fileInfo = data.Data[0];
            Business.showAlert({
              title: 'Info',
              content: 'Update successfully'
          });
            this.setState({
              fileInfo: fileInfo,
              reportDate: Business.convertToDate(fileInfo.report_date),
              reportName: fileInfo.file_name || '',
            })
          }
        }
      })

    this.setState({
      isShowUpdateNameAndReportDateModal: false,
    })
  }

  renderUpdateNameAndReportDateModal = () => {
    return <UpdateNameAndReportDateModalModal
      component={'ICAAP'}
      reportDate={this.state.reportDate}
      reportName={this.state.reportName}
      isShowUpdateNameAndReportDateModal={this.state.isShowUpdateNameAndReportDateModal}
      onCloseUpdateNameAndReportDateModal={this.onCloseUpdateNameAndReportDateModal}
      onCloseUpdateNameAndReportDateModalAndGetNewData={this.onCloseUpdateNameAndReportDateModalAndGetNewData}
    />
  }

  renderBtnUpdateNameAndReportDate = () => {
    return (
      <i style={{ fontSize: 23, color: "red", cursor: "pointer !important" }} className="pe-7s-note" 
        onClick={() => {this.setState({ isShowUpdateNameAndReportDateModal: true })}}>
      </i>
    )
  }

  renderInputFileManagement = () => {
    return (
      <div>
        <div style={{ fontWeight: 500, marginBottom: '10px' }}>
          <a rel="tooltip"
            aria-disabled='true'
            className="btn btn-info btn-simple btn-xs"
            data-original-title="View Profile"
            onClick={() => { this.onDownloadInputFiles(); }}>
            <i style={{ fontSize: 23, color: "red" }} className="pe-7s-download"></i>
          </a>
          <span>Download selected files</span>
        </div>
        <div style={{ position: 'relative', 'height': '300px', overflowY: 'scroll', marginBottom: '30px' }}>
          <table className="table table-hover table-striped">
            <thead>
              <tr>
                <th>
                  <div className="form-check">
                    <input class="form-check-input" type="checkbox" value="" id="checkAllToDownload"
                      onChange={() => this.onSelectInput('SELECT_ALL')}
                      checked={this.state.isSelectAll === true}
                    />
                  </div>
                </th>
                <th>No.</th>
                <th>Input</th>
                <th>Uploader</th>
                <th>Upload Time</th>
              </tr>
            </thead>
            <tbody>
              {
                this.state.lstInput.map((item, index) => (
                  <tr key={item.input}>
                    <td>
                      <div className="form-check">
                        <input class="form-check-input" type="checkbox" value="" id={`checkToDownload_${item.input}`}
                          onChange={() => this.onSelectInput(item.input)}
                          checked={item.select === true}
                        />
                      </div>
                    </td>
                    <td>{index + 1}</td>
                    <td style={{ color: 'blue' }}>{item.input}</td>
                    <td>{item.upload_by}</td>
                    <td>{item.upload_time}</td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      </div>
    )
  }

  renderOutputFileManagement = () => {
    return (
      <div>
        <div style={{ fontWeight: 500, marginBottom: '10px' }}>
          <a rel="tooltip"
            aria-disabled='true'
            className="btn btn-info btn-simple btn-xs"
            data-original-title="View Profile"
            onClick={() => { this.onDownloadOutputFiles(); }}>
            <i style={{ fontSize: 23, color: "red" }} className="pe-7s-download"></i>
          </a>
          <span>Download selected files</span>
        </div>
        <div style={{ position: 'relative', 'height': '300px', overflowY: 'scroll', marginBottom: '30px' }}>
          <table className="table table-hover table-striped">
            <thead>
              <tr>
                <th>
                  <div className="form-check">
                    <input class="form-check-input" type="checkbox" value="" id="checkAllToDownload"
                      onChange={() => this.onSelectOutput('SELECT_ALL')}
                      checked={this.state.isSelectAll === true}
                    />
                  </div>
                </th>
                <th>No.</th>
                <th>Output</th>
                <th>CreatedTime</th>
              </tr>
            </thead>
            <tbody>
              {
                this.state.lstOutput.map((item, index) => (
                  <tr key={item.report_name}>
                    <td>
                      <div className="form-check">
                        <input class="form-check-input" type="checkbox" value="" id={`checkToDownload_${item.report_name}`}
                          onChange={() => this.onSelectOutput(item.report_name)}
                          checked={item.select === true}
                        />
                      </div>
                    </td>
                    <td>{index + 1}</td>
                    <td style={{ color: 'blue' }}>{item.report_name}</td>
                    <td>{item.created}</td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      </div>
    )
  }

  renderIntermediateOutputFileManagement = () => {
    const lstFilterScenario = [];
    for (let e in dicFilterScenario) {
      lstFilterScenario.push(<MenuItem onSelect={(eventKey, event) => { this.handleSelectFilterSecenariosMethod(eventKey, event); }} eventKey={e}>{dicFilterScenario[e]}</MenuItem>);
      lstFilterScenario.push(<MenuItem divider />);
    }
    return (
      <div>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
          <div style={{ fontWeight: 500, marginBottom: '10px' }}>
            <a rel="tooltip"
              aria-disabled='true'
              className="btn btn-info btn-simple btn-xs"
              data-original-title="View Profile"
              onClick={() => { this.onDownloadIntermediateOutputFiles(); }}>
              <i style={{ fontSize: 23, color: "red" }} className="pe-7s-download"></i>
            </a>
            <span>Download selected files</span>
          </div>
          <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
            <div className="form-group">
              <div style={{ display: 'inline', marginRight: 35 }}>
                <DropdownButton title={dicFilterModule[this.state.filterIntermediateOutput.module]} bsSize="small" id={`dropdown-size-${1}`}>
                  <MenuItem onSelect={(eventKey, event) => { this.handleSelectFilterModuleMethod(eventKey, event); }} eventKey={`cr_cor`}>{dicFilterModule['cr_cor']}</MenuItem>
                  <MenuItem divider />
                  <MenuItem onSelect={(eventKey, event) => { this.handleSelectFilterModuleMethod(eventKey, event); }} eventKey={`mr_ccr`}>{dicFilterModule['mr_ccr']}</MenuItem>
                  <MenuItem divider />
                  <MenuItem onSelect={(eventKey, event) => { this.handleSelectFilterModuleMethod(eventKey, event); }} eventKey={`or`}>{dicFilterModule['or']}</MenuItem>
                  <MenuItem divider />
                  <MenuItem onSelect={(eventKey, event) => { this.handleSelectFilterModuleMethod(eventKey, event); }} eventKey={`irrbb_lr`}>{dicFilterModule['irrbb_lr']}</MenuItem>
                </DropdownButton>
              </div>
            </div>
            <div className="form-group">
              <div style={{ display: 'inline', marginRight: 35 }}>
                <label style={{ fontSize: 14, fontWeight: 300, marginRight: 10 }}>Scenario: </label>
                <DropdownButton title={dicFilterScenario[this.state.filterIntermediateOutput.scenario]} bsSize="small" id={`dropdown-size-${1}`}>
                  {
                    lstFilterScenario.map(e => e)
                  }
                </DropdownButton>
              </div>
            </div>
            <div className="form-group">
              <div style={{ display: 'inline', marginRight: 10 }}>
                <label style={{ fontSize: 14, fontWeight: 300, marginRight: 10 }}>Period: </label>
                <DropdownButton title={dicFilterPeriods[this.state.filterIntermediateOutput.period]} bsSize="small" id={`dropdown-size-${1}`}>
                  <MenuItem onSelect={(eventKey, event) => { this.handleSelectFilterPeriodsMethod(eventKey, event); }} eventKey={`all`}>{dicFilterPeriods['all']}</MenuItem>
                  <MenuItem divider />    
                  <MenuItem onSelect={(eventKey, event) => { this.handleSelectFilterPeriodsMethod(eventKey, event); }} eventKey={`none`}>{dicFilterPeriods['none']}</MenuItem>
                  <MenuItem divider />             
                  <MenuItem onSelect={(eventKey, event) => { this.handleSelectFilterPeriodsMethod(eventKey, event); }} eventKey={`t0`}>{dicFilterPeriods['t0']}</MenuItem>
                  <MenuItem divider />
                  <MenuItem onSelect={(eventKey, event) => { this.handleSelectFilterPeriodsMethod(eventKey, event); }} eventKey={`t1`}>{dicFilterPeriods['t1']}</MenuItem>
                  <MenuItem divider />
                  <MenuItem onSelect={(eventKey, event) => { this.handleSelectFilterPeriodsMethod(eventKey, event); }} eventKey={`t2`}>{dicFilterPeriods['t2']}</MenuItem>
                  <MenuItem divider />
                  <MenuItem onSelect={(eventKey, event) => { this.handleSelectFilterPeriodsMethod(eventKey, event); }} eventKey={`t3`}>{dicFilterPeriods['t3']}</MenuItem>
                </DropdownButton>
              </div>
            </div>
          </div>
        </div>
        <div style={{ position: 'relative', 'height': '300px', overflowY: 'scroll', marginBottom: '30px' }}>
          <table className="table table-hover table-striped">
            <thead>
              <tr>
                <th>
                  <div className="form-check">
                    <input class="form-check-input" type="checkbox" value="" id="checkAllToDownload"
                      onChange={() => this.onSelectIntermediateOutput('SELECT_ALL')}
                      checked={this.state.isSelectAll === true}
                    />
                  </div>
                </th>
                <th>No.</th>
                <th>Intermediate Output</th>
                <th>CreatedTime</th>
              </tr>
            </thead>
            <tbody>
              {
                this.state.lstIntermediateOutput.map((item, index) => (
                  <tr key={item.report_name}>
                    <td>
                      <div className="form-check">
                        <input class="form-check-input" type="checkbox" value="" id={`checkToDownload_${item.report_name}`}
                          onChange={() => this.onSelectIntermediateOutput(item.report_name)}
                          checked={item.select === true}
                        />
                      </div>
                    </td>
                    <td>{index + 1}</td>
                    <td style={{ color: 'blue' }}>{item.report_name}</td>
                    <td>{item.created}</td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      </div>
    )
  }

  render() {
    if (this.state.loading || this.state.downloadProgressMessage) return <div style={{ height: Business.getHeightContent() }}><Loading size="small" message={this.state.downloadProgressMessage} /></div>
    const lstMenuScenario = [];
    for (let e in dicScenario) {
      lstMenuScenario.push(<MenuItem onSelect={(eventKey, event) => { this.handleSelectScenario(eventKey, event); }} eventKey={e}>{dicScenario[e]}</MenuItem>);
      lstMenuScenario.push(<MenuItem divider />);
    }
    return (
      <div className="card">
        <div className="header" style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
          {
            (this.state.fileInfo.status 
            && this.state.fileInfo.status !== Business.ENUMS.FILE_STATUS.CALCULATED 
            && this.state.fileInfo.status !== Business.ENUMS.FILE_STATUS.CALCULATING
            ) && this.renderBtnUpdateNameAndReportDate()
          }
          <h4 className="title">{`${this.state.reportDate || ''} # ${Business.convertReportName(this.state.reportName || '', 'ICAAP')} # ${this.state.status || ''}`}</h4>
        </div>
        <div style={{ height: 15 }} />
        <div className="content table-responsive table-full-width">
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div className="form-group">
              <div style={{ display: 'inline' }}>
                <label style={{ fontSize: 14, fontWeight: 300, marginRight: 10 }}>Single Consol: </label>
                <DropdownButton title={dicSingleConsol[this.state.singleConsol]} bsSize="small" id={`dropdown-size-${1}`}>
                  <MenuItem onSelect={(eventKey, event) => { this.handleSelectSingleConsolMethod(eventKey, event); }} eventKey={`single`}>{dicSingleConsol['single']}</MenuItem>
                  <MenuItem divider />
                  <MenuItem onSelect={(eventKey, event) => { this.handleSelectSingleConsolMethod(eventKey, event); }} eventKey={`consol`}>{dicSingleConsol['consol']}</MenuItem>
                  <MenuItem divider />
                </DropdownButton>
              </div>
            </div>
            <div className="form-group">
              <div style={{ display: 'inline' }}>
                <label style={{ fontSize: 14, fontWeight: 300, marginRight: 10 }}>Scenario: </label>
                <DropdownButton title={dicScenario[this.state.scenario]} bsSize="small" id={`dropdown-size-${1}`}>
                  {
                    lstMenuScenario.map(e => e)
                  }
                </DropdownButton>
              </div>
            </div>
          </div>

          {this.renderUpdateNameAndReportDateModal()}

          {this.renderInputFileManagement()}

          {(this.state.fileInfo.status === Business.ENUMS.FILE_STATUS.CALCULATED || this.state.lstOutput.length > 0) && this.renderOutputFileManagement()}

          {(this.state.fileInfo.status === Business.ENUMS.FILE_STATUS.CALCULATED || this.state.lstIntermediateOutput.length > 0) && this.renderIntermediateOutputFileManagement()}

          {console.log(`${this.state.reportName} | file info status: ${this.state.fileInfo.status} | lst output length: ${this.state.lstOutput.length} | lst intermediate output length: ${this.state.lstIntermediateOutput.length}`)}

          <div>
            <FormGroup controlId="formControlsTextarea">
              <label htmlFor="exampleInputEmail1">Reason for rejection: </label>
              <FormControl style={{ height: '100px', resize: 'none' }} disabled={this.state.isDisableReasonInput} componentClass="textarea" value={this.state.reason} placeholder="Type your reason here..." onChange={event => {
                this.setState({ reason: event.target.value })
              }} />
            </FormGroup>
            <div style={{ display: 'inline' }}>
              <button type="button" disabled={this.state.progressValue > 0 || this.state.isDisableRejectButton} className="btn btn-primary"
                style={{
                  backgroundColor: 'rgb(255 0 0)',
                  borderColor: 'rgb(255 255 255)',
                  borderRadius: '5px',
                  fontWeight: 600,
                  marginLeft: 'auto',
                  float: 'left',
                  color: 'white'
                }}
                onClick={() => { this.onReject(); }}>Reject</button>
              <div style={{ display: 'flex', float: 'right' }}>
                <button type="button" disabled={this.state.progressValue > 0 || this.state.isDisableApprovalButton || !Business.isHasRole([Business.ROLE_DEFINE_MAP.ICAAP_APPROVAL_FILES])} className="btn btn-primary"
                  style={{
                    backgroundColor: '#FFE600',
                    borderColor: '#7F7E82',
                    borderRadius: '5px 0px 0px 5px',
                    fontWeight: 600,
                  }}
                  onClick={() => { this.onApproval(); }}>Approval</button>
                <button type="button" disabled={this.state.progressValue > 0 || this.state.isDisableCalculateButton || !Business.isHasRole([Business.ROLE_DEFINE_MAP.ICAAP_CALCULATE])} className="btn btn-primary"
                  style={{
                    backgroundColor: 'rgb(0 255 90)',
                    borderColor: '#7F7E82',
                    borderRadius: '0px 5px 5px 0px',
                    fontWeight: 600,
                  }}
                  onClick={() => { this.onCalculate(); }}>Calculate</button>
              </div>
            </div>
          </div>
          {this.state.errorCode === ErrorCode.PendingBatchProcessing && this.renderPendingBatchProcessing()}
          {this.state.hasResult && this.renderResult()}
        </div>
        <Alert
          title="Are you sure?"
          text="You will not be able to undo!"
          show={this.state.showRejectAlert}
          showCancelButton
          onConfirm={() => { this.onConfirmReject(); }}
          onCancel={() => { this.setState({ showRejectAlert: false }) }}
        />
        <Alert
          title="Some files failed to download!"
          text={`Please check the following files: ${this.state.failedDownloadsList.join(', ')}`}
          show={this.state.showFileDownloadError}
          onConfirm={() => { this.setState({ showFileDownloadError: false }) }}
        />
      </div>
    )
  }
}

const style = {
  bolder: {
    fontWeight: 600
  }
}


let lstIntervalDownload = [];
function clearGetBatchDownloadInterval() {
  lstIntervalDownload.forEach(id => {
    clearInterval(id);
    console.warn(`${id} | Received state: STOP`);
  });
}

async function handleBatchDownload(fileInfo, lstFileSelected, reportDate, reportName, type, component, cb) {
  const res = await Http.createDownloadId(`${uuidv4()}`, lstFileSelected, reportDate, reportName, type, component);
  if (res && res.Success && res.Data) {
    const downloadId = res.Data.download_id;
    const intervalId = setInterval(() => {
      console.warn(`${downloadId} | Request to get batch download`);
      Http.getBatchDownload(downloadId)
        .then(res => {
          if (res) {
            if (res.ErrorCode === ErrorCode.PendingDownload) {
              console.warn(`${downloadId} | Received state: PendingDownload`);
              if (res.Data.progress && res.Data.eta) {
                const message = `Progress: ${res.Data.progress.toFixed(2)}% - EstimatedTime: ${Business.formatSecondsToMinutes(res.Data.eta)}`
                cb && cb(message);
              }
              console.warn(`${downloadId} | Received state: PendingDownload`);
            } else if (res.ErrorCode === ErrorCode.DownloadCompleted) {               
              Http.downloadFileByDownloadId(downloadId, fileInfo.report_date, fileInfo.file_name);
              clearGetBatchDownloadInterval();
              cb && cb();
              console.warn(`${downloadId} | Received state: Success`);
            } else {
              clearGetBatchDownloadInterval();
              cb && cb();
              console.warn(`${downloadId} | Received state: DownloadFailed`);
            }
          }
        })
    }, 3000);
    lstIntervalDownload.push(intervalId);
  }
}

const lstIntervalId = [];
function clearGetBatchResponseInterval(reportName) {
  lstIntervalId.forEach(intervalId => clearInterval(intervalId));
  console.warn(`${reportName} | Received state: STOP`);
}

function toPercentValue(value) {
  if (!value || value === 0) return '';
  return `${(value * 100).toLocaleString('en-GB')}%`;
}

function toAmountValue(value) {
  if (!value || value === 0) return '';
  return `${value.toLocaleString('en-GB')}`;
}


const DEFAULT_REPORT = {
  rwa_e: {
    bau_t0: 0, stress_t0: 0,
    bau_t1: 0, stress_t1: 0,
    bau_t2: 0, stress_t2: 0,
    bau_t3: 0, stress_t3: 0
  },
  rwa_cr: {
    bau_t0: 0, stress_t0: 0,
    bau_t1: 0, stress_t1: 0,
    bau_t2: 0, stress_t2: 0,
    bau_t3: 0, stress_t3: 0
  },
  rwa_or: {
    bau_t0: 0, stress_t0: 0,
    bau_t1: 0, stress_t1: 0,
    bau_t2: 0, stress_t2: 0,
    bau_t3: 0, stress_t3: 0
  },
  rwa_mr: {
    bau_t0: 0, stress_t0: 0,
    bau_t1: 0, stress_t1: 0,
    bau_t2: 0, stress_t2: 0,
    bau_t3: 0, stress_t3: 0
  },
  rwa_cor: {
    bau_t0: 0, stress_t0: 0,
    bau_t1: 0, stress_t1: 0,
    bau_t2: 0, stress_t2: 0,
    bau_t3: 0, stress_t3: 0
  },
  rwa_irrbb: {
    bau_t0: 0, stress_t0: 0,
    bau_t1: 0, stress_t1: 0,
    bau_t2: 0, stress_t2: 0,
    bau_t3: 0, stress_t3: 0
  },
  rwa_omr: {
    bau_t0: 0, stress_t0: 0,
    bau_t1: 0, stress_t1: 0,
    bau_t2: 0, stress_t2: 0,
    bau_t3: 0, stress_t3: 0
  },
  //delta
  delta_rwa: {
    bau_t0: 0, stress_t0: 0,
    bau_t1: 0, stress_t1: 0,
    bau_t2: 0, stress_t2: 0,
    bau_t3: 0, stress_t3: 0
  },
  delta_rwa_cr: {
    bau_t0: 0, stress_t0: 0,
    bau_t1: 0, stress_t1: 0,
    bau_t2: 0, stress_t2: 0,
    bau_t3: 0, stress_t3: 0
  },
  delta_rwa_or: {
    bau_t0: 0, stress_t0: 0,
    bau_t1: 0, stress_t1: 0,
    bau_t2: 0, stress_t2: 0,
    bau_t3: 0, stress_t3: 0
  },
  delta_rwa_mr: {
    bau_t0: 0, stress_t0: 0,
    bau_t1: 0, stress_t1: 0,
    bau_t2: 0, stress_t2: 0,
    bau_t3: 0, stress_t3: 0
  },
  delta_rwa_cor: {
    bau_t0: 0, stress_t0: 0,
    bau_t1: 0, stress_t1: 0,
    bau_t2: 0, stress_t2: 0,
    bau_t3: 0, stress_t3: 0
  },
  delta_rwa_irrbb: {
    bau_t0: 0, stress_t0: 0,
    bau_t1: 0, stress_t1: 0,
    bau_t2: 0, stress_t2: 0,
    bau_t3: 0, stress_t3: 0
  },
  delta_rwa_omr: {
    bau_t0: 0, stress_t0: 0,
    bau_t1: 0, stress_t1: 0,
    bau_t2: 0, stress_t2: 0,
    bau_t3: 0, stress_t3: 0
  },
  //Von tu co
  von_tu_co_ca: {
    bau_t0: 0, stress_t0: 0,
    bau_t1: 0, stress_t1: 0,
    bau_t2: 0, stress_t2: 0,
    bau_t3: 0, stress_t3: 0
  },
  //Von yeu cau
  von_yeu_cau_cr: {
    bau_t0: 0, stress_t0: 0,
    bau_t1: 0, stress_t1: 0,
    bau_t2: 0, stress_t2: 0,
    bau_t3: 0, stress_t3: 0
  },
  //Von kinh te
  von_kinh_te_ce: {
    bau_t0: 0, stress_t0: 0,
    bau_t1: 0, stress_t1: 0,
    bau_t2: 0, stress_t2: 0,
    bau_t3: 0, stress_t3: 0
  },
  //Thue suat
  corp_tax: {
    bau_t0: 0, stress_t0: 0,
    bau_t1: 0, stress_t1: 0,
    bau_t2: 0, stress_t2: 0,
    bau_t3: 0, stress_t3: 0
  },
  //Delta PNL
  delta_pnl: {
    bau_t0: 0, stress_t0: 0,
    bau_t1: 0, stress_t1: 0,
    bau_t2: 0, stress_t2: 0,
    bau_t3: 0, stress_t3: 0
  },
  thay_doi_thu_nhap_lai: {
    bau_t0: 0, stress_t0: 0,
    bau_t1: 0, stress_t1: 0,
    bau_t2: 0, stress_t2: 0,
    bau_t3: 0, stress_t3: 0
  },
  thay_doi_chi_phi_du_phong: {
    bau_t0: 0, stress_t0: 0,
    bau_t1: 0, stress_t1: 0,
    bau_t2: 0, stress_t2: 0,
    bau_t3: 0, stress_t3: 0
  },
  thay_doi_thu_nhap_tu_rui_ro_thi_truong: {
    bau_t0: 0, stress_t0: 0,
    bau_t1: 0, stress_t1: 0,
    bau_t2: 0, stress_t2: 0,
    bau_t3: 0, stress_t3: 0
  },
  ton_that_rui_ro_hoat_dong: {
    bau_t0: 0, stress_t0: 0,
    bau_t1: 0, stress_t1: 0,
    bau_t2: 0, stress_t2: 0,
    bau_t3: 0, stress_t3: 0
  },
  chi_phi_thanh_khoan: {
    bau_t0: 0, stress_t0: 0,
    bau_t1: 0, stress_t1: 0,
    bau_t2: 0, stress_t2: 0,
    bau_t3: 0, stress_t3: 0
  },
  ty_le_an_toan_von_car: {
    bau_t0: 0, stress_t0: 0,
    bau_t1: 0, stress_t1: 0,
    bau_t2: 0, stress_t2: 0,
    bau_t3: 0, stress_t3: 0
  },
  ty_le_an_toan_von_cap_1_ct1: {
    bau_t0: 0, stress_t0: 0,
    bau_t1: 0, stress_t1: 0,
    bau_t2: 0, stress_t2: 0,
    bau_t3: 0, stress_t3: 0
  },
  ty_le_an_toan_von_chu_so_huu_cap_1_cet1: {
    bau_t0: 0, stress_t0: 0,
    bau_t1: 0, stress_t1: 0,
    bau_t2: 0, stress_t2: 0,
    bau_t3: 0, stress_t3: 0
  },
  ty_le_don_bay: {
    bau_t0: 0, stress_t0: 0,
    bau_t1: 0, stress_t1: 0,
    bau_t2: 0, stress_t2: 0,
    bau_t3: 0, stress_t3: 0
  },
  roe: {
    bau_t0: 0, stress_t0: 0,
    bau_t1: 0, stress_t1: 0,
    bau_t2: 0, stress_t2: 0,
    bau_t3: 0, stress_t3: 0
  },
  raroc: {
    bau_t0: 0, stress_t0: 0,
    bau_t1: 0, stress_t1: 0,
    bau_t2: 0, stress_t2: 0,
    bau_t3: 0, stress_t3: 0
  }
}

export default FileInfo;



// WEBPACK FOOTER //
// ./src/pages/RAROC/FileManagement/FileInfo.js